import { Modal } from "PFComponents/modal";
import { useTranslation } from "react-i18next";

type PublishConfirmModalProps = {
  templateName: string;
  onOk: () => void;
  onClose: () => void;
};

export const PublishConfirmModal = ({ templateName, onOk, onClose }: PublishConfirmModalProps) => {
  const { t } = useTranslation("activities");
  return (
    <Modal title={t("form.modals.noRequirements")} onOK={onOk} onClose={onClose}>
      {t("form.modals.creatingNoRequirementsWarning", { templateName })}
    </Modal>
  );
};
